module.exports = __webpack_public_path__ + "img/logo1.7ea67ed8.png";